import { Container, CircularProgress } from '@mui/material';

const ProgressBar = ({ isLoading, children }) => {
  if (isLoading) {
    return (
      <Container
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          mt: 10,
          mb: 10,
        }}
      >
        <CircularProgress />
      </Container>
    );
  }

  return children;
};

export default ProgressBar;
